import { View, StyleSheet } from 'react-native';

import { spacing } from '../../../theme';
import { InputError } from './InputError';

interface Props {
	errors?: string[];
}

export const InputErrors = ({ errors }: Props) => {
	if (!errors || errors.length === 0) {
		return null;
	}

	return (
		<View style={styles.root}>
			{errors.map((errorText) => (
				<InputError key={errorText} errorText={errorText} />
			))}
		</View>
	);
};

export const styles = StyleSheet.create({
	root: {
		flexDirection: 'column',
		marginTop: spacing(),
	},
});
